import {
  get,
  getDatabase,
  limitToLast,
  onValue,
  orderByChild,
  query,
  ref,
} from "firebase/database";
import { dbApp } from "./config2";
//import { initConfig } from "./compat";
import {
  createSkeletons,
  getAvailableSkeleton,
  getRadioLink,
  getStars,
  removeExtraSkeletons,
} from "./global";

//import { gplay } from "google-play-scraper";
//const gplay = require("google-play-scraper");
const MAX_RADIOS = 10;
const MAX_REVIEWS = 10;
const radioContainer = document.getElementById("radioContainer");
const radioTemplate = document.getElementById("radioTemplate");
const reviewsContainer = document.getElementById("reviewsContainer");
const reviewsTemplate = document.getElementById("reviewsTemplate");
const APP_ID = "app.myandroidhello.com.chatmurcianys";

let activeLs = [];
$("document").ready(function () {
  initFrameLs();
  loadTopRadios();
  loadReviews();
});
function initFrameLs() {
  window.addEventListener("beforeunload", () => {
    activeLs.forEach((stopLs) => {
      stopLs();
    });
  });
}
async function loadTopRadios() {
  const radioCards = createSkeletons(radioTemplate, MAX_RADIOS, radioContainer);
  const db = dbApp;
  const dbRadio = ref(db, `Radio Stations`);
  const radioQuery = query(
    dbRadio,
    orderByChild("info/numLikes"),
    limitToLast(MAX_RADIOS),
  );
  const radioLs = onValue(radioQuery, (snapshot) => {
    if (snapshot.exists()) {
      const topItems = [];
      snapshot.forEach((child) => {
        const key = child.key;
        topItems.push({
          id: key,
          ...child.val().info,
        });
      });
      topItems.reverse();
      topItems.forEach((radio) => {
        let skeletonCard = getAvailableSkeleton(
          radio.id,
          radioContainer,
          radioTemplate,
        );
        setRadioCardUi(skeletonCard, radio.id, radio);
      });
    } else {
      removeExtraSkeletons(radioContainer);
    }
  });
  activeLs.push(radioLs);
  //get(radioQuery).then((data) => {});
}

function setRadioCardUi(card, key, data) {
  card.id = key;
  card.querySelector(".radio-name").textContent = data.radio_Name;
  let radioimg = card.querySelector("img");
  radioimg.src = data.radio_image || radioimg.src;
  card.querySelector("a").href = getRadioLink(data.radio_Name);
  card.removeAttribute("loading");
}
async function loadReviews() {
  const reviewsList = await getReviews();
  if (reviewsList && reviewsList.length > 0) {
    reviewsList.forEach((review) => {
      let skeletonCard = getAvailableSkeleton(
        review.id,
        reviewsContainer,
        reviewsTemplate,
      );
      console.log("skeleton: ", skeletonCard.querySelector(".user-name"));

      setReviewUi(skeletonCard, review);
    });
    if (reviewsContainer) {
      console.log("reviews container exists");
      removeExtraSkeletons(reviewsContainer);
    } else {
      console.log("reviewscontainer is null");
    }
  }
}

function setReviewUi(card, review) {
  card.id = review.id;
  const imgUser = card.querySelector("img");
  imgUser.src = review.userImage || imgUser.src;
  card.querySelector(".user-name").textContent = review.userName;
  card.querySelector(".review-date").textContent = review.date;
  card.querySelector(".star-rating").innerHTML = getStars(review.score);
  card.querySelector(".review-text").textContent = review.text;
  card.removeAttribute("loading");
}
async function getReviews() {
  const reviewCards = createSkeletons(
    reviewsTemplate,
    MAX_RADIOS,
    reviewsContainer,
  );
  try {
    // Construct the URL with query parameters
    //const url = `http://localhost:5000/api/reviews?appId=${APP_ID}&count=${MAX_REVIEWS}`;
    const url = `/gplay/reviews?appId=${APP_ID}&count=${MAX_REVIEWS}`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    }

    const reviewsData = await response.json();
    console.log(`Fetched ${reviewsData.length} reviews:`, reviewsData.data);
    return reviewsData.data;
  } catch (error) {
    console.error("Failed to get reviews:", error);
  }
}
